var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tw-mx-auto tw-max-w-7xl tw-px-4 sm:tw-px-6 lg:tw-px-8"},[_c('sign-up')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }